import { useState } from 'react'
import { ViewProps, SearchInput } from '@codeleap/web'
import { CardBase, Text, View, Button } from '@/components'
import { ReviewCard } from './ReviewCard'

type OrganisationHeaderProps = Partial<ViewProps<'div'>>

export function EmployeeReviewsCard(props: OrganisationHeaderProps) {
  const { ...otherProps } = props

  const [selected, setSelected] = useState('reviews')
  return (
    <CardBase
      debugName='Employee Reviews'
      variants={['backgroundColor:neutral1', 'padding:4', 'border-radius:medium', 'card:elevated', 'review']}
      {...otherProps}
    >
      <View variants={['fullWidth', 'column']}>
        <Text text='Employee Reviews' variants={['h3', 'color:neutral9']} />

        <View variants={['column']}>
          <View variants={['marginVertical:2', 'backgroundColor:neutral2', 'border-radius:medium']}>
            <Button
              debugName='reviews button'
              text='Reviews'
              variants={['fullWidth', 'border-radius:medium', selected === 'reviews' ? 'reviews:selected' : 'reviews']}
              onPress={() => setSelected('reviews')}
            />
            <Button
              debugName='success stories button'
              text='Success Stories'
              variants={['fullWidth', 'border-radius:medium', selected === 'stories' ? 'reviews:selected' : 'reviews']}
              onPress={() => setSelected('stories')}
            />
          </View>

          <View variants={['column']}>
            <SearchInput type='search' debugName='search employee review' placeholder='Search' variants={['noError']} />

            <View variants={['column', 'marginTop:2', 'gap:2']}>
              <ReviewCard title='Review 1' date='Jul, 2023' text='Review 1 text' progress={100} />
              <ReviewCard title='Review 2' date='Jul, 2023' text='Review 2 text' progress={75} />
              <ReviewCard title='Review 3' date='Jul, 2023' text='Review 3 text' progress={50} />
              <ReviewCard title='Review 4' date='Jul, 2023' text='Review 4 text' progress={85} />
            </View>
          </View>
        </View>
      </View>
    </CardBase>
  )
}
